export const getSegmentCssWidth = (paddingX) => {
    return `calc(1ch + ${paddingX} * 2)`;
};
